<template lang="pug">
  Popup(:visible="visible")
    .exchange-goods-popup
      img.exchange-goods-popup-close(
        src="https://m.hellobike.com/resource/gallery/833/dRaJxJTBwm.png"
        alt=""
        @click="handleClosePopup"
      )
      img.exchange-goods-popup-title(
        src="https://m.hellobike.com/resource/gallery/833/T9Dnf8yuMU.png"
        alt=""
      )
      .exchange-goods-popup-content
        template(v-for="(item, index) in list")
          .exchange-goods-item
            SafeImg(className="exchange-goods-item-logo" :src="item.image")
            .exchange-goods-item-name {{ item.title }}
            .exchange-goods-item-desc 需{{ item.amount }}奖励金
            .exchange-goods-item-btn(@click="handleItemClick(item)") 选TA
</template>

<script>
import Popup from '@/components/popup.vue';
import SafeImg from '@/components/safe-img.vue';
import SPM from '../common/spm';

export default {
  name: 'ExchangeGoodsPopup',
  components: { Popup, SafeImg },
  props: {
    // 是否显示弹窗
    visible: {
      type: Boolean,
      default: false,
    },
    // 商品列表
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  watch: {
    // 弹窗展示监听
    visible(val) {
      if (val) {
        SPM.moduleExpose({
          moduleId: 'Welfare_newedupop',
          contentId: 'Welfare_newedupop',
          businessInfo: {},
        });
      }
    },
  },
  mounted() {},
  methods: {
    // 关闭弹窗
    handleClosePopup() {
      this.$emit('close');
      // 点击埋点上报
      SPM.clickButton({
        buttonName: 'Welfare_newedupop_close',
        businessInfo: {},
      });
    },
    // 点击商品
    handleItemClick(item) {
      this.$emit('itemClick', item, 'popup');
      // 点击埋点上报
      SPM.clickButton({
        buttonName: 'Welfare_newedupop_sku',
        businessInfo: {},
      });
    },
  },
};
</script>

<style lang="less" scoped>
.exchange-goods-popup {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 2.31rem;

  .exchange-goods-popup-close {
    position: absolute;
    top: -0.08rem;
    right: -0.24rem;
    width: 0.2rem;
    height: 0.2rem;
  }

  .exchange-goods-popup-title {
    width: 2.19rem;
    height: 0.21rem;
  }

  .exchange-goods-popup-content {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 0.16rem;
  }

  .exchange-goods-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 0.9rem;
  }

  .exchange-goods-item-logo {
    overflow: hidden;
    width: 0.9rem;
    height: 0.58rem;
    border-radius: 0.08rem;
    border: 0.005rem solid #fff;
    background-color: #f0f3f5;
    box-sizing: border-box;
  }

  .exchange-goods-item-name {
    margin-top: 0.08rem;
    width: 120%;
    font-weight: 600;
    font-size: 0.16rem;
    color: #fff;
    line-height: 0.2rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
  }

  .exchange-goods-item-desc {
    margin-top: 0.02rem;
    line-height: 0.17rem;
    font-size: 0.12rem;
    color: #bcc4cc;
  }

  .exchange-goods-item-btn {
    display: flex;
    align-items: center;
    margin-top: 0.08rem;
    padding: 0 0.16rem;
    margin-bottom: 0.17rem;
    height: 0.22rem;
    background-color: #ff5526;
    border-radius: 0.22rem;
    line-height: normal;
    font-size: 0.12rem;
    color: #fff;
  }
}
</style>
